import { useEffect, useState } from "react";
import { X, Trash2, Users, GitBranch } from "lucide-react";
import { Avatar } from "../saker/Avatar";

const Knapp = ({ onClick, children, testid, dus }) => (
  <button
    type="button"
    onClick={onClick}
    className={`w-full flex items-center gap-2 px-2.5 py-1.5 rounded-lg text-[12px] text-left hover:bg-neutral-50 transition-colors ${dus ? "text-neutral-400" : "text-neutral-700"}`}
    data-testid={testid}
  >
    {children}
  </button>
);

export function BulkBar({ antall, alleValgt, onVelgAlle, stages, stageFarge, stageLabel, members = [], onStadium, onAnsvarlig, onSlett, onLukk, t }) {
  const [meny, setMeny] = useState(null);

  useEffect(() => {
    const esc = (e) => { if (e.key === "Escape") { setMeny(null); onLukk(); } };
    window.addEventListener("keydown", esc);
    return () => window.removeEventListener("keydown", esc);
  }, [onLukk]);

  return (
    <div className="fixed bottom-5 left-1/2 -translate-x-1/2 z-40 sak-modal bg-white border border-[#E7E4DB] rounded-full shadow-2xl pl-4 pr-1.5 py-1.5 flex items-center gap-1.5 max-w-[calc(100vw-24px)]" data-testid={`${t}-bulk-bar`}>
      <span className="text-[12px] font-semibold text-neutral-900 tabular-nums whitespace-nowrap">{antall} valgt</span>
      <button
        type="button"
        onClick={onVelgAlle}
        className="text-[11px] font-medium text-neutral-500 hover:text-neutral-900 px-1 transition-colors whitespace-nowrap"
        data-testid={`${t}-bulk-alle`}
      >
        {alleValgt ? "Ingen" : "Alle"}
      </button>
      <span className="w-px h-4 bg-[#E7E4DB]" />
      <div className="relative">
        <button
          type="button"
          disabled={!antall}
          onClick={() => setMeny((m) => (m === "stage" ? null : "stage"))}
          className="inline-flex items-center gap-1 text-[11.5px] font-medium text-neutral-600 rounded-full px-2 py-1 hover:bg-neutral-50 transition-colors disabled:opacity-40 whitespace-nowrap"
          data-testid={`${t}-bulk-stadium`}
        >
          <GitBranch size={11} /> Stadium
        </button>
        {meny === "stage" && (
          <>
            <div className="fixed inset-0 z-30" onClick={() => setMeny(null)} />
            <div className="sak-modal absolute left-0 bottom-full mb-1.5 z-40 w-[190px] max-h-[280px] overflow-y-auto bg-white border border-[#E7E4DB] rounded-xl shadow-xl p-1.5" data-testid={`${t}-bulk-stadium-meny`}>
              {stages.map((st) => (
                <Knapp key={st.k} onClick={() => { setMeny(null); onStadium(st.k); }} testid={`${t}-bulk-stadium-${st.k}`}>
                  <span className="w-1.5 h-1.5 rounded-full shrink-0" style={{ background: stageFarge(st.k) }} />
                  {st.label}
                </Knapp>
              ))}
            </div>
          </>
        )}
      </div>
      <div className="relative">
        <button
          type="button"
          disabled={!antall}
          onClick={() => setMeny((m) => (m === "owner" ? null : "owner"))}
          className="inline-flex items-center gap-1 text-[11.5px] font-medium text-neutral-600 rounded-full px-2 py-1 hover:bg-neutral-50 transition-colors disabled:opacity-40 whitespace-nowrap"
          data-testid={`${t}-bulk-ansvarlig`}
        >
          <Users size={11} /> Ansvarlig
        </button>
        {meny === "owner" && (
          <>
            <div className="fixed inset-0 z-30" onClick={() => setMeny(null)} />
            <div className="sak-modal absolute left-0 bottom-full mb-1.5 z-40 w-[190px] max-h-[280px] overflow-y-auto bg-white border border-[#E7E4DB] rounded-xl shadow-xl p-1.5" data-testid={`${t}-bulk-ansvarlig-meny`}>
              {members.map((m) => (
                <Knapp key={m.id} onClick={() => { setMeny(null); onAnsvarlig(m.id, m.name); }} testid={`${t}-bulk-ansvarlig-${m.id}`}>
                  <Avatar person={m} size={16} /> {m.name}
                </Knapp>
              ))}
              <div className="my-1 border-t border-neutral-100" />
              <Knapp dus onClick={() => { setMeny(null); onAnsvarlig(null, ""); }} testid={`${t}-bulk-ansvarlig-ingen`}>Fjern ansvarlig</Knapp>
            </div>
          </>
        )}
      </div>
      <button
        type="button"
        disabled={!antall}
        onClick={onSlett}
        className="inline-flex items-center gap-1 text-[11.5px] font-semibold text-red-600 rounded-full px-2 py-1 hover:bg-red-50 transition-colors disabled:opacity-40 whitespace-nowrap"
        data-testid={`${t}-bulk-slett`}
      >
        <Trash2 size={11} /> Slett
      </button>
      <button
        type="button"
        onClick={onLukk}
        className="w-7 h-7 rounded-full bg-neutral-900 text-white flex items-center justify-center hover:bg-neutral-700 transition-colors"
        title="Avslutt valgmodus"
        data-testid={`${t}-bulk-avbryt`}
      >
        <X size={13} />
      </button>
    </div>
  );
}
